import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=7c126fad&scoped=true&"
import script from "./CommonForm.vue?vue&type=script&lang=js&"
export * from "./CommonForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=7c126fad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c126fad",
  null
  
)

export default component.exports